function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
// disabled for tab-index on focus traps, which are intentionally non-interactive

import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import memoize from 'memoize-one';
import { Operator as FilterOperator, assertOperatorValue as assertFilterOperatorValue } from '@deephaven/filters';
import { dhSortAmountDown, dhNewCircleLargeFilled, vsScreenFull, vsScreenNormal } from '@deephaven/icons';
import { TableUtils } from '@deephaven/jsapi-utils';
import { Button, ContextActionUtils } from '@deephaven/components';
import Log from '@deephaven/log';
import { assertNotNull, PromiseUtils } from '@deephaven/utils';
import { nanoid } from 'nanoid';
import AdvancedFilterCreatorFilterItem from "./AdvancedFilterCreatorFilterItem.js";
import AdvancedFilterCreatorSelectValue from "./AdvancedFilterCreatorSelectValue.js";
import "./AdvancedFilterCreator.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var log = Log.module('AdvancedFilterCreator');
class AdvancedFilterCreator extends PureComponent {
  static makeFilterItem() {
    return {
      key: nanoid()
    };
  }
  constructor(props) {
    var _options$filterItems$, _options$filterItems;
    super(props);
    _defineProperty(this, "focusTrapContainer", void 0);
    _defineProperty(this, "debounceTimeout", void 0);
    _defineProperty(this, "valuesTablePromise", void 0);
    _defineProperty(this, "getFilterTypes", memoize(columnType => TableUtils.getFilterTypes(columnType)));
    this.handleAddAnd = this.handleAddAnd.bind(this);
    this.handleAddOr = this.handleAddOr.bind(this);
    this.handleChangeFilterOperator = this.handleChangeFilterOperator.bind(this);
    this.handleDone = this.handleDone.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleFilterDelete = this.handleFilterDelete.bind(this);
    this.handleSelectValueChange = this.handleSelectValueChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleSortDown = this.handleSortDown.bind(this);
    this.handleSortUp = this.handleSortUp.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFocusTrapStart = this.handleFocusTrapStart.bind(this);
    this.handleFocusTrapEnd = this.handleFocusTrapEnd.bind(this);
    this.handleUpdateTimeout = this.handleUpdateTimeout.bind(this);
    this.focusTrapContainer = /*#__PURE__*/React.createRef();
    var model = props.model,
      column = props.column,
      options = props.options;
    var filterOperators = options.filterOperators,
      invertSelection = options.invertSelection,
      selectedValues = options.selectedValues;

    // can be null or an empty array
    var filterItems = (_options$filterItems$ = (_options$filterItems = options.filterItems) === null || _options$filterItems === void 0 ? void 0 : _options$filterItems.map(_ref => {
      var selectedType = _ref.selectedType,
        value = _ref.value;
      return {
        selectedType,
        value,
        key: nanoid()
      };
    })) !== null && _options$filterItems$ !== void 0 ? _options$filterItems$ : [];
    if (filterItems.length === 0) {
      filterItems.push(AdvancedFilterCreator.makeFilterItem());
    }
    if (filterOperators == null) {
      filterOperators = [];
    }
    if (invertSelection == null) {
      invertSelection = true;
    }
    if (selectedValues == null) {
      selectedValues = [];
    }
    var columnIndex = model.getColumnIndexByName(column.name);
    assertNotNull(columnIndex);
    var isSortable = model.isColumnSortable(columnIndex);
    this.state = {
      // Filter items
      filterItems,
      // And/Or between the filter items
      filterOperators,
      invertSelection,
      selectedValues,
      valuesTableError: null,
      valuesTable: undefined,
      isSortable
    };
  }
  componentDidMount() {
    this.initValuesTable();
  }
  componentWillUnmount() {
    if (this.debounceTimeout != null) {
      clearTimeout(this.debounceTimeout);
      this.sendUpdate();
    }
    if (this.valuesTablePromise != null) {
      this.valuesTablePromise.cancel();
    }
  }
  getFilterChangeHandler(index) {
    return this.handleFilterChange.bind(this, index);
  }
  getFilterDeleteHandler(index) {
    return this.handleFilterDelete.bind(this, index);
  }
  initValuesTable() {
    var _this$props = this.props,
      model = _this$props.model,
      column = _this$props.column;
    if (!model.isValuesTableAvailable) {
      log.debug('No values table for this model, just ignore');
      return;
    }
    this.valuesTablePromise = TableUtils.makeCancelableTablePromise(model.valuesTable(column));
    this.valuesTablePromise.then(valuesTable => {
      var _valuesTable$columns$;
      if ((_valuesTable$columns$ = valuesTable.columns[0].isSortable) !== null && _valuesTable$columns$ !== void 0 ? _valuesTable$columns$ : true) {
        var sort = valuesTable.columns[0].sort().asc();
        valuesTable.applySort([sort]);
      }
      this.setState({
        valuesTable
      });
    }).catch(error => {
      if (PromiseUtils.isCanceled(error)) {
        return;
      }
      log.error('Unable to open values table', error);
      this.setState({
        valuesTableError: error
      });
    });
  }
  handleFocusTrapEnd() {
    var _this$focusTrapContai;
    ((_this$focusTrapContai = this.focusTrapContainer) === null || _this$focusTrapContai === void 0 || (_this$focusTrapContai = _this$focusTrapContai.current) === null || _this$focusTrapContai === void 0 ? void 0 : _this$focusTrapContai.querySelector('button,select,input,textarea')).focus();
  }
  handleFocusTrapStart() {
    var _this$focusTrapContai2;
    var inputs = (_this$focusTrapContai2 = this.focusTrapContainer) === null || _this$focusTrapContai2 === void 0 || (_this$focusTrapContai2 = _this$focusTrapContai2.current) === null || _this$focusTrapContai2 === void 0 ? void 0 : _this$focusTrapContai2.querySelectorAll('button,select,input,textarea');
    if (inputs && inputs.length > 0) {
      var element = inputs[inputs.length - 1];
      element.focus();
    }
  }
  handleAddAnd() {
    var _this$state = this.state,
      filterItems = _this$state.filterItems,
      filterOperators = _this$state.filterOperators;
    filterItems = filterItems.concat(AdvancedFilterCreator.makeFilterItem());
    filterOperators = filterOperators.concat(FilterOperator.and);
    this.setState({
      filterItems,
      filterOperators
    });
  }
  handleAddOr() {
    var _this$state2 = this.state,
      filterItems = _this$state2.filterItems,
      filterOperators = _this$state2.filterOperators;
    filterItems = filterItems.concat(AdvancedFilterCreator.makeFilterItem());
    filterOperators = filterOperators.concat(FilterOperator.or);
    this.setState({
      filterItems,
      filterOperators
    });
  }
  handleChangeFilterOperator(index, operator) {
    var filterOperators = this.state.filterOperators;
    filterOperators = [...filterOperators];
    assertFilterOperatorValue(operator);
    filterOperators[index] = operator;
    this.setState({
      filterOperators
    });
    this.startUpdateTimer();
  }
  handleFilterChange(filterIndex, selectedType, value) {
    var filterItems = this.state.filterItems;
    filterItems = [...filterItems];
    var key = filterItems[filterIndex].key;
    filterItems[filterIndex] = {
      key,
      selectedType,
      value
    };
    this.setState({
      filterItems
    });
    this.startUpdateTimer();
  }
  handleFilterDelete(filterIndex) {
    var _this$state3 = this.state,
      filterItems = _this$state3.filterItems,
      filterOperators = _this$state3.filterOperators;
    filterItems = [...filterItems];
    filterOperators = [...filterOperators];
    if (filterIndex < filterItems.length) {
      filterItems.splice(filterIndex, 1);
    }
    if (filterIndex < filterOperators.length) {
      filterOperators.splice(filterIndex, 1);
    } else if (filterIndex === filterOperators.length) {
      // When deleting the last filter item, we also need to remove the last filter operator
      filterOperators.splice(filterOperators.length - 1, 1);
    }
    if (filterItems.length === 0) {
      filterItems.push(AdvancedFilterCreator.makeFilterItem());
    }
    this.setState({
      filterItems,
      filterOperators
    });
    this.startUpdateTimer();
  }
  handleSelectValueChange(selectedValues, invertSelection) {
    this.setState({
      selectedValues,
      invertSelection
    });
    this.startUpdateTimer();
  }
  handleReset() {
    log.debug('Resetting Advanced Filter');
    this.setState({
      filterItems: [AdvancedFilterCreator.makeFilterItem()],
      filterOperators: [],
      selectedValues: [],
      invertSelection: true
    });
    this.startUpdateTimer();
  }
  handleSortDown(event) {
    var addToExisting = ContextActionUtils.isModifierKeyDown(event);
    this.sortTable(TableUtils.sortDirection.descending, addToExisting);
  }
  handleSortUp(event) {
    var addToExisting = ContextActionUtils.isModifierKeyDown(event);
    this.sortTable(TableUtils.sortDirection.ascending, addToExisting);
  }
  handleSubmit(event) {
    log.debug('Submitting Advanced Filter');
    this.stopUpdateTimer();
    this.sendUpdate();
    event.preventDefault();
  }
  handleDone(event) {
    log.debug('Submitting and Closing Advanced Filter');
    this.stopUpdateTimer();
    this.sendUpdate();
    var onDone = this.props.onDone;
    onDone();
    event.preventDefault();
  }
  handleUpdateTimeout() {
    this.debounceTimeout = undefined;
    this.sendUpdate();
  }

  /**
   * Convenience function to check if the previous filter has been inputted, and
   * we should show the add filter buttons (+ AND OR)
   * @returns true If the add filter buttons should be shown, false otherwise
   */
  shouldShowAddFilter() {
    var filterItems = this.state.filterItems;
    if (filterItems.length === 0) {
      return false;
    }
    var filterItem = filterItems[filterItems.length - 1];
    var selectedType = filterItem.selectedType,
      value = filterItem.value;
    return selectedType != null && selectedType.length > 0 && value != null && value.length > 0;
  }

  /**
   * Sorts the table in the specified direction. If already sorted in that direction, remove it.
   * @param direction The sort direction, ASC or DESC
   * @param addToExisting Add to the existing sort, or replace the existing table sort
   */
  sortTable(direction) {
    var addToExisting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var _this$props2 = this.props,
      column = _this$props2.column,
      onSortChange = _this$props2.onSortChange;
    var isSortable = this.state.isSortable;
    if (isSortable) {
      onSortChange(column, direction, addToExisting);
    }
  }
  startUpdateTimer() {
    this.stopUpdateTimer();
    this.debounceTimeout = setTimeout(this.handleUpdateTimeout, AdvancedFilterCreator.debounceFilterUpdate);
  }
  stopUpdateTimer() {
    if (this.debounceTimeout !== undefined) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = undefined;
    }
  }
  sendUpdate() {
    var _this$state4 = this.state,
      filterItems = _this$state4.filterItems,
      filterOperators = _this$state4.filterOperators,
      invertSelection = _this$state4.invertSelection,
      selectedValues = _this$state4.selectedValues;
    var _this$props3 = this.props,
      column = _this$props3.column,
      onFilterChange = _this$props3.onFilterChange,
      model = _this$props3.model,
      tableUtils = _this$props3.tableUtils;
    var formatter = model.formatter;
    var items = filterItems.filter(_ref2 => {
      var selectedType = _ref2.selectedType,
        value = _ref2.value;
      return selectedType != null && value != null && value !== '';
    });
    var operators = filterOperators.filter((operator, i) => operator != null && filterItems[i].selectedType != null && filterItems[i].value != null && filterItems[i].value !== '').slice(0, items.length - 1);
    // slice last operator, user may have set an operator but not a value

    var options = {
      filterItems: items,
      filterOperators: operators,
      invertSelection,
      selectedValues
    };
    var filter = tableUtils.makeAdvancedFilter(column, options, formatter.timeZone);
    onFilterChange(column, filter, options);
  }
  render() {
    var _this = this;
    var _this$props4 = this.props,
      column = _this$props4.column,
      model = _this$props4.model,
      sortDirection = _this$props4.sortDirection,
      formatter = _this$props4.formatter,
      tableUtils = _this$props4.tableUtils,
      isMaximized = _this$props4.isMaximized,
      onToggleMaximize = _this$props4.onToggleMaximize;
    var _this$state5 = this.state,
      filterItems = _this$state5.filterItems,
      filterOperators = _this$state5.filterOperators,
      invertSelection = _this$state5.invertSelection,
      selectedValues = _this$state5.selectedValues,
      valuesTable = _this$state5.valuesTable,
      valuesTableError = _this$state5.valuesTableError,
      isSortable = _this$state5.isSortable;
    var dh = model.dh,
      isValuesTableAvailable = model.isValuesTableAvailable;
    var isBoolean = TableUtils.isBooleanType(column.type);
    var isDateType = TableUtils.isDateType(column.type);
    var filterTypes = this.getFilterTypes(column.type);
    var columnType = column.type.substring(column.type.lastIndexOf('.') + 1);
    var filterItemElements = [];
    if (!isBoolean && filterTypes.length) {
      var _loop = function _loop(i) {
        var filterItem = filterItems[i];
        var key = filterItem.key,
          selectedType = filterItem.selectedType,
          value = filterItem.value;
        var element = /*#__PURE__*/_jsx(AdvancedFilterCreatorFilterItem, {
          column: column,
          filterTypes: filterTypes,
          onChange: _this.getFilterChangeHandler(i),
          onDelete: _this.getFilterDeleteHandler(i),
          selectedType: selectedType,
          value: value,
          formatter: formatter,
          tableUtils: tableUtils
        }, key);
        filterItemElements.push(element);
        if (i < filterOperators.length) {
          var filterOperator = filterOperators[i];
          var isAndFilter = filterOperator === FilterOperator.and;
          var operatorElement = /*#__PURE__*/_jsxs("div", {
            className: "form-row justify-content-end advanced-filter-creator-filter-operator",
            children: [/*#__PURE__*/_jsx(Button, {
              kind: "ghost",
              className: classNames('filter-operator', {
                active: isAndFilter
              }),
              onClick: () => _this.handleChangeFilterOperator(i, FilterOperator.and),
              children: "AND"
            }), /*#__PURE__*/_jsx(Button, {
              kind: "ghost",
              className: classNames('filter-operator', {
                active: !isAndFilter
              }),
              onClick: () => _this.handleChangeFilterOperator(i, FilterOperator.or),
              children: "OR"
            })]
          }, "filterOperator".concat(key));
          filterItemElements.push(operatorElement);
        }
      };
      for (var i = 0; i < filterItems.length; i += 1) {
        _loop(i);
      }
    }
    var showAddFilterItem = this.shouldShowAddFilter();
    var addFilterItem = /*#__PURE__*/_jsxs("div", {
      className: classNames('form-row justify-content-end add-filter-item', {
        hidden: !showAddFilterItem
      }),
      children: [/*#__PURE__*/_jsx("span", {
        className: "text-muted",
        children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: dhNewCircleLargeFilled
        })
      }), /*#__PURE__*/_jsx(Button, {
        kind: "ghost",
        className: "btn-filter-item",
        onClick: this.handleAddAnd,
        disabled: !showAddFilterItem,
        tooltip: "Add filter with AND",
        children: "AND"
      }), /*#__PURE__*/_jsx(Button, {
        kind: "ghost",
        className: "btn-filter-item",
        onClick: this.handleAddOr,
        disabled: !showAddFilterItem,
        tooltip: "Add filter with OR",
        children: "OR"
      })]
    }, "addFilterItem");
    filterItemElements.push(addFilterItem);
    return /*#__PURE__*/_jsxs("div", {
      className: "advanced-filter-creator",
      role: "presentation",
      children: [/*#__PURE__*/_jsx("div", {
        tabIndex: 0,
        onFocus: this.handleFocusTrapStart
      }), /*#__PURE__*/_jsxs("form", {
        onSubmit: this.handleSubmit,
        ref: this.focusTrapContainer,
        children: [/*#__PURE__*/_jsxs("div", {
          className: "title-bar",
          children: [/*#__PURE__*/_jsx("h6", {
            className: "advanced-filter-title",
            children: "Advanced Filters"
          }), /*#__PURE__*/_jsxs("div", {
            className: "advanced-filter-menu-buttons",
            children: [/*#__PURE__*/_jsx(Button, {
              kind: "ghost",
              className: classNames('sort-operator', {
                active: sortDirection === TableUtils.sortDirection.descending
              }),
              onClick: this.handleSortDown,
              icon: dhSortAmountDown,
              tooltip: isSortable ? "Sort ".concat(column.name, " Descending") : 'Not sortable',
              disabled: !isSortable
            }), /*#__PURE__*/_jsx(Button, {
              kind: "ghost",
              className: classNames('sort-operator', {
                active: sortDirection === TableUtils.sortDirection.ascending
              }),
              onClick: this.handleSortUp,
              icon: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: dhSortAmountDown,
                rotation: 180
              }),
              tooltip: isSortable ? "Sort ".concat(column.name, " Ascending") : 'Not sortable',
              disabled: !isSortable
            }), /*#__PURE__*/_jsx(Button, {
              kind: "ghost",
              className: classNames('sort-operator', {
                active: isMaximized
              }),
              onClick: onToggleMaximize,
              icon: isMaximized ? vsScreenNormal : vsScreenFull,
              tooltip: isMaximized ? 'Restore dialog size' : 'Maximize dialog'
            })]
          })]
        }), /*#__PURE__*/_jsx("hr", {}), /*#__PURE__*/_jsxs("div", {
          className: "advanced-filter-column-name",
          children: [column.name, "\xA0", /*#__PURE__*/_jsxs("span", {
            className: "column-type",
            children: ["(", columnType, ")"]
          })]
        }), filterItemElements, isValuesTableAvailable && valuesTableError == null && /*#__PURE__*/_jsxs(_Fragment, {
          children: [!isBoolean && /*#__PURE__*/_jsx("hr", {}), /*#__PURE__*/_jsx("div", {
            className: "form-group advanced-filter-values-group",
            children: /*#__PURE__*/_jsx(AdvancedFilterCreatorSelectValue, {
              dh: dh,
              table: valuesTable,
              onChange: this.handleSelectValueChange,
              invertSelection: invertSelection,
              selectedValues: selectedValues,
              formatter: formatter,
              showSearch: !isDateType,
              timeZone: formatter.timeZone
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "form-row justify-content-end",
          children: [/*#__PURE__*/_jsx(Button, {
            kind: "secondary",
            className: "mr-2",
            onClick: this.handleReset,
            children: "Reset"
          }), /*#__PURE__*/_jsx(Button, {
            kind: "primary",
            onClick: this.handleDone,
            children: "Done"
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        tabIndex: 0,
        onFocus: this.handleFocusTrapEnd
      })]
    });
  }
}
_defineProperty(AdvancedFilterCreator, "debounceFilterUpdate", 250);
_defineProperty(AdvancedFilterCreator, "defaultProps", {
  options: {
    filterItems: null,
    filterOperators: null,
    invertSelection: true,
    selectedValues: []
  },
  sortDirection: null
});
export default AdvancedFilterCreator;
//# sourceMappingURL=AdvancedFilterCreator.js.map